<template>
  <div class="login-box">
    <v-container>
      <v-row>
        <div class="heading">
          <h1>SE CONNECTER</h1>
          <p>
            Nouveau utilisateur ?
            <span @click="onRegisterClick">Créer Un Compte</span>
          </p>
        </div>
      </v-row>
      <v-row>
        <v-form>
          <v-text-field
            ref="mail"
            name="login"
            :error="error != null"
            v-model="mail"
            :rules="mailRules"
            label="Adresse mail"
            placeholder="Ecriver votre adresse mail .. "
            required
            @keyup.enter="onSigninEmail"
          ></v-text-field>
          <v-text-field
            :error="error != null"
            v-model="password"
            :rules="pwdRules"
            id="password"
            type="password"
            @keyup.enter="onSigninEmail"
            name="password"
            ref="password"
            label="Mot de pass"
            placeholder="********"
            required
          ></v-text-field>
          <!-- reset password link -->
          <span class="resetLink" @click="$router.push('/resetReq')"
            >j'ai oublié mon mot de passe.</span
          >
          <br />
          <button
            class="cnxBtn"
            type="button"
            v-on:click="onSigninEmail"
            :loading="loading"
          >
            Continuer
          </button>
        </v-form>
      </v-row>
      <!-- <v-row>
        <div class="logBt">
          <p class="orText">Ou</p>
          <form method="POST" :action="googleUrl">
            <input type="hidden" name="type" value="user" />
            <button type="sublit" class="googleBtn" :loading="loading">
              <v-icon>mdi-google</v-icon>
              Continuer avec Google
            </button>
          </form>
        </div>
      </v-row> -->
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FacebookLogin from "@/components/FacebookLogin";

export default {
  props: { close: Boolean },
  components: {
    FacebookLogin,
  },
  data() {
    return {
      fbAppId: process.env.VUE_APP_FB_ID,
      fbAppId: process.env.VUE_APP_API_URL_GOOGLE_USER,
      mail: "",
      password: "",
      valid: true,
      pwdRules: [
        (v) => !!v || "Mot de passe est obligatoire",
        (v) =>
          (v && v.length >= 6) || "Mot de pass doit être plus que 6 caractères",
      ],
      mailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  computed: {
    ...mapGetters({ user: "user", loading: "loading", error: "error" }),
  },
  methods: {
    ...mapActions(["signUserInGoogle", "loginUserEmail", "clearError"]),
    onClose() {
      this.$emit("close-dialog");
    },
    onSigninFacebook() {
      window.location = "https://localhost:3000/api/auth/facebook";
      // this.$store.dispatch("signUserInFacebookPassport");
    },
    onSigninEmail() {
      this.loginUserEmail({
        mail: this.mail,
        password: this.password,
      });
    },
    onDismissed() {
      this.clearError();
    },
    onRegisterClick() {
      this.clearError();
      this.$router.push("/register");
    },
  },
};
</script>

<style scoped>
.login-box {
  height: 100%;
  background: #fafafa;
  padding: 15px 60px;
  border-top-left-radius: 50px;
  border-bottom-right-radius: 50px;
  display: grid;
  align-content: center;
}
.heading h1 {
  font-size: 32px;
  letter-spacing: 2px;
  font-style: italic;
  font-weight: bold;
}
.heading p {
  margin: 0;
  color: #ababab;
  font-size: 17px;
}
.heading span {
  color: #ed595d;
  font-size: 17px;
  cursor: pointer;
  margin-left: 10px;
}
.v-form {
  width: 100%;
  margin: 30px 0;
}
.v-input {
  margin-bottom: 10px !important;
}
.resetLink {
  cursor: pointer;
  color: #ababab;
  font-size: 16px;
}
.cnxBtn {
  background: #e91e24;
  color: #fff;
  padding: 5px 30px;
  border-radius: 7px;
  float: right;
  letter-spacing: 1px;
  margin-top: 10px;
}
.logBt {
  text-align: center;
  width: 100%;
}
.orText {
  color: #777777;
  font-size: 23px;
  font-weight: bold;
}
.googleBtn {
  border: 2px solid #ed595d;
  padding: 7px 0;
  width: 300px;
  border-radius: 50px;
  color: #223038;
  font-size: 17px;
  font-weight: bold;
  margin: 0 auto 10px auto;
  line-height: 1.3;
  display: block;
  transition: all 0.3s ease-in-out;
}
.googleBtn .v-icon {
  font-size: 33px;
  color: #db4437;
  margin-right: 25px;
  display: inline-flex;
}
.googleBtn:hover {
  border: 2px solid #ed595d;
  color: #fff;
  background: #ed595d;
}
.googleBtn:hover .v-icon {
  color: #fff;
}
@media screen and (max-width: 900px) {
  .login-box {
    padding: 30px 10px;
  }
}
</style>